import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'occurred_at', label: 'Date' },
  { key: 'asset', label: 'Asset' },
  { key: 'field', label: 'Field' },
  { key: 'from', label: 'From' },
  { key: 'to', label: 'To' },
  { key: 'changed_by', label: 'Changed By' },
];

export function AssetMovementLogReport() {
  return (
    <ReportView
      title="Asset Movement Log"
      description="Location, department and custodian changes for every asset, from the activity log."
      endpoint="/reports/resources/asset-movement-log"
      columns={COLUMNS}
      filters={['dateRange']}
      defaultSort="occurred_at"
    />
  );
}
